module.exports = __webpack_public_path__ + "static/media/editFill.ba6a4fd5.svg";